import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const UpcomingevtVistas = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}
        </div>

        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-session-vistas">Counselling Session</Link>
          </li>
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          {/* <li>
            <Link to="/update-vistas">Updates</Link>
          </li>
          <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li> */}
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
        </Slider>
      </div>
      <div className="padding-wid  drak-bg vistas_p">
        <div className="container">
          <div className="text-center d-block">
            <h3 className="mx-auto text-black font-play">Upcoming Events</h3>
          </div>
          <div className="row">
            <div className="col-md-12 textarea">
              <section>
                <ul className="list">
                  <li className="font-play">
                    CAREER FAIR 27 April 2026{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/april-fair.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    CAREER FAIR 2026 April{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/c-fair.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Yuva Vigyani Karyakram (YUVIKA) 2026–27 by Indian Space
                    Research Organisation (ISRO) For Grade X (2026–27){" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/circular.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Psychometric Testing and Counselling for Subject Selection –
                    Grade X{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/aptitude.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Registration Open for IIT Madras School Connect Program
                    –APRIL2026 Batch GRADES X-XII{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/madras.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Austrade Career Fair on August 24th, from 8:30 AM onwards
                    and a Special Session by Ms. Neha Grover, Director, Trade
                    &amp; Investment- Education, Australian High Commission, New
                    Delhi{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/poster.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Mandatory Aptitude Test for Grade X Learners{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Mandatory-Aptitude-Test-For-Grade-X-Learners.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    LOR and transcript request{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/LOR-and-transcript-request.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Mindful Journaling Workshop by Akanksha Parashar on 21st and
                    22nd May, 2024{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/Mindful-journaling.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    Session on CUET - The Common University Entrance Test on
                    April 09 from 9:00 am onwards.
                  </li>
                  <li className="font-play">
                    Career Fair- April 27, 2024{" "}
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/ea7349a8-0769-4c40-869f-0a8a53c3035a.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="text-primary"
                    >
                      Click Here
                    </a>
                  </li>
                  <li className="font-play">
                    In-house Career Counselling Session for Grade XII in March
                    2024
                    <ul className="list">
                      <li>ABOUT CUET</li>
                      <li>
                        An Excel Tracker For Program/ University(AB Activity)
                      </li>
                    </ul>
                  </li>
                  <li className="font-play">
                    In-house Career Counselling Session for Grade X in April
                    2024
                    <ul className="list">
                      <li>Overview about Careers (Home and Abroad)</li>
                      <li>Essentials of Psychometric Testing-API</li>
                      <li>AB Activity-My profile</li>
                    </ul>
                  </li>
                  <li className="font-play">
                    In-house Career Counselling Session for Grade XII in April
                    2024
                    <ul className="list">
                      <li>
                        Writing my Statement of Purpose (SOP)(AB Activity)
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div>
    </>
  );
};
export default UpcomingevtVistas;
